module.exports = __webpack_public_path__ + "static/media/ico_duplicate_o.afc76dcf.svg";